// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___QbJ29","totalContainer":"totalContainer___kkpNN"};